/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CarpentryInputs */

const en_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpentry`)
};

const es_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpintería`)
};

const fr_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menuiserie`)
};

const de_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreinerei`)
};

const ja_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大工工事`)
};

const zh_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`木工服务`)
};

const ar_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نجارة`)
};

const id_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertukangan`)
};

const it_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falegnameria`)
};

const ru_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Столярное дело`)
};

const pt_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpintaria`)
};

const ko_val_carpentry = /** @type {(inputs: Val_CarpentryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목공`)
};

/**
* | output |
* | --- |
* | "Carpentry" |
*
* @param {Val_CarpentryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_carpentry = /** @type {((inputs?: Val_CarpentryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CarpentryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_carpentry(inputs)
	if (locale === "es") return es_val_carpentry(inputs)
	if (locale === "fr") return fr_val_carpentry(inputs)
	if (locale === "de") return de_val_carpentry(inputs)
	if (locale === "ja") return ja_val_carpentry(inputs)
	if (locale === "zh") return zh_val_carpentry(inputs)
	if (locale === "ar") return ar_val_carpentry(inputs)
	if (locale === "id") return id_val_carpentry(inputs)
	if (locale === "it") return it_val_carpentry(inputs)
	if (locale === "ru") return ru_val_carpentry(inputs)
	if (locale === "pt") return pt_val_carpentry(inputs)
	return ko_val_carpentry(inputs)
});